import React from "react";
import "./styles.less";
import { Table, Column } from "../../components/NormalTable";
import { useTranslation } from "react-i18next";

const renderChecked = (value) => {
  const iconStyl = {
    color: "#A6ADB4",
    textAlign:"center",
    margin:"0 auto",
    display:"block"
    // color: "rgba(57, 106, 255, 0.8)",
  };
  const checkedIcon = <div><i className="icon authing-icon authing-wancheng" style={iconStyl}></i></div>;
  return value === "checked" ? checkedIcon : value;
};
export const OktaContentTable = () => {
  const { t } = useTranslation();
  const data = [
    {
      title: `${t("solution.okta.compare.item1.title")}`,
      descript: `${t("solution.okta.compare.item1.subtitle")}`,
      okta: "checked",
      authing: "checked",
      yufu: "checked",
      jiuzhou: "checked",
    },
    {
      title: `${t("solution.okta.compare.item2.title")}`,
      descript: `${t("solution.okta.compare.item2.subtitle")}`,
      okta: "checked",
      authing: "checked",
      yufu: "",
      jiuzhou: "",
    },
    {
      title: `${t("solution.okta.compare.item3.title")}`,
      descript: `${t("solution.okta.compare.item3.subtitle")}`,
      okta: "checked",
      authing: "checked",
      yufu: "checked",
      jiuzhou: "checked",
    },
    {
      title: `${t("solution.okta.compare.item4.title")}`,
      descript: `${t("solution.okta.compare.item4.subtitle")}`,
      okta: "checked",
      authing: "checked",
      yufu: "checked",
      jiuzhou: "checked",
    },
    {
      title: `${t("solution.okta.compare.item5.title")}`,
      descript: `${t("solution.okta.compare.item5.subtitle")}`,
      okta: "checked",
      authing: "checked",
      yufu: "",
      jiuzhou: "checked",
    },
    {
      title: `${t("solution.okta.compare.item6.title")}`,
      descript: `${t("solution.okta.compare.item6.subtitle")}`,
      okta: "checked",
      authing: "checked",
      yufu: "",
      jiuzhou: "",
    },
  ];
  const renderTitle = (value, data) => {
    return (
      <div className="colum-title" style={{ fontSize: 16 }}>
        <span>{value}</span>
      </div>
    );
  };
  return (
    <div className="okta-table">
      <div className="title" id="okta_replace">
        {t("solution.okta.replace.title")}
      </div>
      <div className="overview">
        <p>{t("solution.okta.replace.description1")}</p>
        <p>{t("solution.okta.replace.description2")}</p>
      </div>
      <div className="compare" id="okta_compare">
        <Table data={data}>
          <Column title="" dataIndex="title" align="" render={renderTitle} />
          <Column title="" dataIndex="descript" align="left" />
          <Column title="Okta" dataIndex="okta" align="left" render={renderChecked} />
          <Column title="Authing" dataIndex="authing" align="center" render={renderChecked} />
          <Column title={t("solution.okta.compare.yvfu")} dataIndex="yufu" align="center" render={renderChecked} />
          <Column title={t("solution.okta.compare.jiuzhou")} dataIndex="jiuzhou" align="center" render={renderChecked} />
        </Table>
      </div>
    </div>
  );
};
